import { Coordinates, MapOptions } from '../../../../core/types/types';

export const mapContainerProps = (
    mapCenterCoords: Coordinates,
    mapZoomLevel: number,
    isDecreaseZoomControlAmount: boolean,
    isLoading: boolean,
    mapOptions: MapOptions,
) => {
    return {
        className: 'mapContainer',
        center: isLoading ? { lat: 23.8859, lng: 45.0792 } : mapCenterCoords,
        zoom: isLoading ? 8 : mapZoomLevel,
        zoomDelta: isDecreaseZoomControlAmount ? 0.01 : 1,
        zoomSnap: isDecreaseZoomControlAmount ? 0.01 : 1,
        scrollWheelZoom: mapOptions.attributes.canZoom,
        zoomControl: mapOptions.attributes.canZoom,
        minZoom: 5,
        doubleClickZoom: false,
        attributionControl: false,
        //@ts-ignore
        rotate: true,
    };
};
